<mat-toolbar *ngIf="showTimeOutStatus" style="height: min-content;"> {{ idleState }} </mat-toolbar>

<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<router-outlet> <app-spinner></app-spinner> </router-outlet>